export default __webpack_public_path__ + "static/media/footer-shape.90309c1f.svg";